import * as Yup from 'yup';

const stateFormFields = [
  'straightRefiBorrower',
  'straightRefiCoBorrower',
  'add',
  'drop',
  'addDrop',
  'nameChangeBorrower',
  'nameChangeCoBorrower',
];
const filterFormFields = (field: string) => stateFormFields.filter((currentField) => currentField !== field);

export const stateTabSchema = Yup.object().shape(
  {
    stateCode: Yup.string().required(),
    straightRefiBorrower: Yup.array().when(filterFormFields('straightRefiBorrower'), {
      is: (
        straightRefiCoBorrower: string[],
        add: string[],
        drop: string[],
        addDrop: string[],
        nameChangeBorrower: string[],
        nameChangeCoBorrower: string[]
      ) =>
        straightRefiCoBorrower?.length === 0 &&
        add?.length === 0 &&
        drop?.length === 0 &&
        addDrop?.length === 0 &&
        nameChangeBorrower?.length === 0 &&
        nameChangeCoBorrower?.length === 0,
      then: Yup.array().of(Yup.string().required()).min(1, 'Select atleast one Stip Type'),
    }),
    straightRefiCoBorrower: Yup.array().when(filterFormFields('straightRefiCoBorrower'), {
      is: (
        straightRefiBorrower: string[],
        add: string[],
        drop: string[],
        addDrop: string[],
        nameChangeBorrower: string[],
        nameChangeCoBorrower: string[]
      ) =>
        straightRefiBorrower?.length === 0 &&
        add?.length === 0 &&
        drop?.length === 0 &&
        addDrop?.length === 0 &&
        nameChangeBorrower?.length === 0 &&
        nameChangeCoBorrower?.length === 0,
      then: Yup.array().of(Yup.string().required()).min(1, 'Select atleast one Stip Type'),
    }),
    add: Yup.array().when(filterFormFields('add'), {
      is: (
        straightRefiCoBorrower: string[],
        straightRefiBorrower: string[],
        drop: string[],
        addDrop: string[],
        nameChangeBorrower: string[],
        nameChangeCoBorrower: string[]
      ) =>
        straightRefiCoBorrower?.length === 0 &&
        straightRefiBorrower?.length === 0 &&
        drop?.length === 0 &&
        addDrop?.length === 0 &&
        nameChangeBorrower?.length === 0 &&
        nameChangeCoBorrower?.length === 0,
      then: Yup.array().of(Yup.string().required()).min(1, 'Select atleast one Stip Type'),
    }),
    drop: Yup.array().when(filterFormFields('drop'), {
      is: (
        straightRefiCoBorrower: string[],
        straightRefiBorrower: string[],
        add: string[],
        addDrop: string[],
        nameChangeBorrower: string[],
        nameChangeCoBorrower: string[]
      ) =>
        straightRefiCoBorrower?.length === 0 &&
        straightRefiBorrower?.length === 0 &&
        add?.length === 0 &&
        addDrop?.length === 0 &&
        nameChangeBorrower?.length === 0 &&
        nameChangeCoBorrower?.length === 0,
      then: Yup.array().of(Yup.string().required()).min(1, 'Select atleast one Stip Type'),
    }),
    addDrop: Yup.array().when(filterFormFields('addDrop'), {
      is: (
        straightRefiCoBorrower: string[],
        straightRefiBorrower: string[],
        add: string[],
        drop: string[],
        nameChangeBorrower: string[],
        nameChangeCoBorrower: string[]
      ) =>
        straightRefiCoBorrower?.length === 0 &&
        straightRefiBorrower?.length === 0 &&
        add?.length === 0 &&
        drop?.length === 0 &&
        nameChangeBorrower?.length === 0 &&
        nameChangeCoBorrower?.length === 0,
      then: Yup.array().of(Yup.string().required()).min(1, 'Select atleast one Stip Type'),
    }),
    nameChangeBorrower: Yup.array().when(filterFormFields('nameChangeBorrower'), {
      is: (
        straightRefiCoBorrower: string[],
        straightRefiBorrower: string[],
        add: string[],
        drop: string[],
        addDrop: string[],
        nameChangeCoBorrower: string[]
      ) =>
        straightRefiCoBorrower?.length === 0 &&
        straightRefiBorrower?.length === 0 &&
        add?.length === 0 &&
        drop?.length === 0 &&
        addDrop?.length === 0 &&
        nameChangeCoBorrower?.length === 0,
      then: Yup.array().of(Yup.string().required()).min(1, 'Select atleast one Stip Type'),
    }),
    nameChangeCoBorrower: Yup.array().when(filterFormFields('nameChangeCoBorrower'), {
      is: (
        straightRefiCoBorrower: string[],
        straightRefiBorrower: string[],
        add: string[],
        drop: string[],
        addDrop: string[],
        nameChangeBorrower: string[]
      ) =>
        straightRefiCoBorrower?.length === 0 &&
        straightRefiBorrower?.length === 0 &&
        add?.length === 0 &&
        drop?.length === 0 &&
        addDrop?.length === 0 &&
        nameChangeBorrower?.length === 0,
      then: Yup.array().of(Yup.string().required()).min(1, 'Select atleast one Stip Type'),
    }),
  },
  [
    ['straightRefiBorrower', 'add'],
    ['straightRefiBorrower', 'straightRefiCoBorrower'],
    ['straightRefiBorrower', 'drop'],
    ['straightRefiBorrower', 'addDrop'],
    ['straightRefiBorrower', 'nameChangeBorrower'],
    ['straightRefiBorrower', 'nameChangeCoBorrower'],
    ['straightRefiCoBorrower', 'add'],
    ['straightRefiCoBorrower', 'addDrop'],
    ['straightRefiCoBorrower', 'nameChangeBorrower'],
    ['straightRefiCoBorrower', 'nameChangeCoBorrower'],
    ['straightRefiCoBorrower', 'drop'],
    ['add', 'drop'],
    ['add', 'addDrop'],
    ['add', 'nameChangeBorrower'],
    ['add', 'nameChangeCoBorrower'],
    ['drop', 'addDrop'],
    ['drop', 'nameChangeBorrower'],
    ['drop', 'nameChangeCoBorrower'],
    ['addDrop', 'nameChangeBorrower'],
    ['addDrop', 'nameChangeCoBorrower'],
    ['nameChangeBorrower', 'nameChangeCoBorrower'],
  ]
);

export const lenderTabSchema = Yup.object().shape({
  lenderId: Yup.string().required(),
  stipType: Yup.array().of(Yup.string().required()).min(1, 'Stip Type are required'),
});
